import React from 'react';
import classnames from 'classnames';
import { useIntl } from 'umi';
import { Bubble } from '@home/components/TeaComponents';

import './index.scss';

// 列的左右padding分别各为20px，左右加起来为40px
const TABLE_HORIZONTAL_PADDING = 40;

export interface IColumnAlignerProps extends IBaseProps {
  style?: React.CSSProperties;
  className?: string;
  useHighlightTitleColor?: Boolean;
  highlightTitleColor?: string;
  hoverTipsKey?: string;
  align: 'left' | 'right' | 'center';
  width?: number | string;
  children: React.ReactNode;
}

const ColumnAligner: React.FC<IColumnAlignerProps> = (props) => {
  const {
    style,
    className,
    useHighlightTitleColor = false,
    highlightTitleColor = '#262832',
    hoverTipsKey = '',
    width,
    align,
    children,
  } = props;

  const { formatMessage } = useIntl();

  const mergedStyle = {
    ...style,
    display: 'inline-block',
    width: width === '100%' ? width : (Number(width) || 140) - TABLE_HORIZONTAL_PADDING,
    textAlign: align,
    verticalAlign: 'middle',
    color: useHighlightTitleColor ? highlightTitleColor : '',
  };

  const mergedClassName = classnames('dbi-column-aligner', className, align);

  const bubbleContent = !hoverTipsKey ? undefined : formatMessage({ id: hoverTipsKey });

  return (
    <Bubble dark arrowPointAtCenter content={bubbleContent}>
      <div style={mergedStyle} className={mergedClassName}>
        {children}
      </div>
    </Bubble>
  );
};

export default ColumnAligner;
